// Font Awesome configuration - Only import icons that are actually used
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Import specific icons from solid
import {
  faAngleLeft,
  faBars,
  faBell as fasBell,
  faBoxes,
  faCheckCircle,
  faCheck,
  faChevronDown,
  faArrowsAlt,
  faArrowUp,
  faArrowDown,
  faTrash,
  faReply,
  faCreditCard,
  faYenSign,
  faMoneyCheckAlt,
  faWineBottle,
  faTruck,
  faThumbsUp,
  faGem,
  faWarehouse,
  faStickyNote,
  faTrademark,
  faTemperatureHigh,
  faEnvelope as fasEnvelope,
  faSignOutAlt,
  faThLarge,
  faGavel,
  faTrophy,
  faChartLine,
  faChartBar,
  faUser,
  faStar
} from '@fortawesome/free-solid-svg-icons'

// Import specific icons from regular
import {
  faBell as farBell,
  faEnvelope as farEnvelope
} from '@fortawesome/free-regular-svg-icons'

// Import specific icons from brands
import {
  faCcVisa,
  faCcAmex,
  faCcJcb,
  faCcMastercard
} from '@fortawesome/free-brands-svg-icons'

// Add icons to the library
library.add(
  // Solid icons
  faAngleLeft,
  faBars,
  fasBell,
  faBoxes,
  faCheckCircle,
  faCheck,
  faChevronDown,
  faArrowsAlt,
  faArrowUp,
  faArrowDown,
  faTrash,
  faReply,
  faCreditCard,
  faYenSign,
  faMoneyCheckAlt,
  faWineBottle,
  faTruck,
  faThumbsUp,
  faGem,
  faWarehouse,
  faStickyNote,
  faTrademark,
  faTemperatureHigh,
  fasEnvelope,
  faSignOutAlt,
  faThLarge,
  faGavel,
  faTrophy,
  faChartLine,
  faChartBar,
  faUser,
  faStar,
  // Regular icons
  farBell,
  farEnvelope,
  // Brand icons
  faCcVisa,
  faCcAmex,
  faCcJcb,
  faCcMastercard
)

// Convert i tags to SVG
dom.watch()

// For compatibility with CSS @extend usage, we need to add CSS classes
// This allows the existing SCSS @extend directives to work
import '@fortawesome/fontawesome-svg-core/styles.css'